<template>
	<o-section :title="task.isNew ? `Ajouter une tâche` : `Modifier une tâche`">
		<div class="task-modal-edit">
			<o-alert
				v-if="!task.id"
				color="default">
				Renseignez une tâche à effectuer pour ce candidat.<br>
			</o-alert>

			<div class="task-modal-edit__selection">
				<task-modal-edit-card
					v-for="(taskType, i) in setup.taskTypeOptions"
					:key="`${taskType}-${i}`"
					v-bind="{
						task: setup.taskClone,
						taskType,
						selectedTaskType: setup.selectedTaskType,
						assignedUserOptions: setup.assignedUserOptions,
					}"
					@click="setup.selectedTaskType = taskType"
					@close="setup.selectedTaskType = undefined"/>
			</div>
		</div>
	</o-section>

	<o-section
		align="right"
		gap="xs">
		<o-button
			color="danger"
			nude
			@click="_modal?.close()">
			Annuler
		</o-button>
		<o-button
			:disabled="setup.taskClone.isFilled ? false : true"
			:color="setup.taskClone.isFilled ? 'brand' : 'default'"
			:outline="setup.taskClone.isFilled ? false : true"
			:loading="task.isPerformingAjax"
			@click="task.isNew ? task.storeAsync() : task.updateAsync()">
			{{ task.id ? 'Modifier' : 'Ajouter' }}
		</o-button>
	</o-section>
</template>

<script setup lang="ts">
import TaskModalEditCard from './TaskModalEditCard.vue';
import TaskModalEditSetupService from '@/setup/task/TaskModalEditSetupService';
import { inject } from 'vue';
const _modal = inject<OrionModal>('_modal');
const props = defineProps(TaskModalEditSetupService.props);
const setup = new TaskModalEditSetupService(props, _modal);
</script>

<style scoped lang="less">
@import '@/styles/mixins.less';
@import '@/styles/variables.less';


.task-modal-edit {
	display: flex;
	flex-direction: column;

	&__selection {
		display: flex;
		gap: 1.25rem;
		margin-bottom: 0.75rem;

		@media @phone {
			flex-direction: column;
		}
	}

	.orion-alert {
		margin-bottom: 1.25rem;
	}
}
</style>
